module.exports = "https://cdn2-fs.clearscore.com/flux/images/93a6ad435be23387d5395e8580478800.jpg";